import React from "react";
import { Link } from "react-router-dom";
import { NonIdealState, Button } from "@blueprintjs/core";

const Classic = ({ icon, title, desc, url, buttonIntent }) => {
    return (
        <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            <NonIdealState
                icon={icon}
                title={title}
                description={desc}
                action={
                    <Link to={url}>
                        <Button text="Create session" icon="add" intent={buttonIntent} />
                    </Link>
                }
            />
        </div>
    )
}

export default Classic